import { useTranslation } from '@ecomm/i18n'
import { AlarmMoments } from '../index'
import { TabBreakIn } from './TabBreakIn'
import { TabFire } from './TabFire'
import { TabPackageTheft } from './TabPackageTheft'
import { TabTemp } from './TabTemp'
import { TabWater } from './TabWater'

export function UKHomePageAlarmMoments() {
  const { t } = useTranslation('alarm-moments')
  const alarmMomentsTabs = [
    {
      label: t('label.break-in'),
      title: t('title.during-alarm'),
      description: t('description.during-alarm'),
      tab: <TabBreakIn />
    },
    {
      label: t('label.smoke-co'),
      title: t('title.during-alarm'),
      description: t('description.during-alarm'),
      tab: <TabFire />
    },
    {
      label: t('label.water'),
      title: t('title.during-alarm'),
      description: t('description.during-alarm'),
      tab: <TabWater />
    },
    {
      label: t('label.temperature'),
      title: t('title.during-alarm'),
      description: t('description.during-alarm'),
      tab: <TabTemp />
    },
    {
      label: t('label.deliveries'),
      title: t('title.during-alarm'),
      description: t('description.during-alarm'),
      tab: <TabPackageTheft />
    }
  ] as const
  return <AlarmMoments tabs={alarmMomentsTabs} />
}
